import { render, staticRenderFns } from "./ListArticleStats.vue?vue&type=template&id=2a3f4e0c&scoped=true"
import script from "./ListArticleStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleStats.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleStats.vue?vue&type=style&index=0&id=2a3f4e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f4e0c",
  null
  
)

export default component.exports